import { render, staticRenderFns } from "./AuthorityList.vue?vue&type=template&id=10708ee0&scoped=true&"
import script from "./AuthorityList.vue?vue&type=script&lang=js&"
export * from "./AuthorityList.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityList.vue?vue&type=style&index=0&id=10708ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10708ee0",
  null
  
)

export default component.exports